import React from 'react';

import { Row, Col } from 'antd';
import { Field, FormikProps } from 'formik';

// REDUX
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import data from 'store/modules/api/detranCrv/enum';

// COMPONENTS
import Section from 'components/Common/Section';
import Placa from 'components/Common/Form/Fields/Placa';
import InputMask from 'components/Common/Form/Input/InputMask';
import Input from 'components/Common/Form/Input/Input';
import Select from 'components/Common/Form/Select';

// UTILS
import hasError from 'utils/getFormErrors';
import { onlyNumbers } from 'utils/genericFunctions';

// FORM
import BuscarMarcas from 'components/Common/SearchButtons/Marcas';
import { initialValues } from '../form';

interface Props {
	formik: FormikProps<any>;
}

const DadosVeiculo: React.FC<Props> = ({ formik }) => {
	const {
		consultaCategoria,
		consultaCarroceria,
		consultaCombustivel,
		consultaCor,
		consultaEspecie,
		consultarMunicipioPorUF,
		consultaTipo,
	} = useSelector((state: ApplicationState) => state.api.detranCrv.Enum);

	return (
		<>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Section size="lg" title="Dados do Veículo" titleSize="sm">
						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Placa
									title="Placa"
									titleSize="lg"
									name="placa"
									defaultValue={initialValues.placa}
									size={80}
									// required
									formik={formik}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Select}
									title="Município"
									titleSize="lg"
									name="codigoMunicipio"
									options={consultarMunicipioPorUF.data}
									onChange={(v: number) => {
										formik.setFieldValue('codigoMunicipio', v);

										const selectedItem = consultarMunicipioPorUF.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue(
											'descricaoMunicipio',
											selectedItem[0].label,
										);
									}}
									size={92}
									required
									error={hasError(formik.errors, 'municipio')}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={10}>
								<Field
									as={Input}
									title="Marca"
									titleSize="lg"
									name="descricaoMarca"
									size={95}
									// required
									disabled
									// error={!!formik.errors.descricaoMarca}
								/>
							</Col>

							<Col>
								<BuscarMarcas
									result={res => {
										formik.setFieldValue('longIdMarca', res.longId);
										formik.setFieldValue('descricaoMarca', res.descricao);
									}}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={InputMask}
									title="Ano Fabricação"
									titleSize="lg"
									name="anoFabricacao"
									mask="9999"
									size={80}
									// error={!!formik.errors.anoFabricacao}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={InputMask}
									title="Ano Modelo"
									titleSize="lg"
									name="anoModelo"
									mask="9999"
									size={92}
									// required
									// error={!!formik.errors.anoModelo}
								/>
							</Col>
						</Row>
						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Input}
									title="Chassi"
									titleSize="lg"
									name="chassi"
									maxLength={22}
									size={80}
									// required
									// error={!!formik.errors.chassi}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Select}
									title="Chassi Remarcado"
									titleSize="lg"
									name="chassiRemarcado"
									options={data.simNaoBoolean}
									size={92}
									required
									error={!!formik.errors.chassiRemarcado}
									onChange={(v: boolean) => {
										formik.setFieldValue('chassiRemarcado', v);
									}}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Input}
									title="Número do Espelho"
									titleSize="lg"
									name="numeroEspelho"
									maxLength={12}
									size={80}
									required
									onChange={(v: React.ChangeEvent<HTMLInputElement>) => {
										formik.setFieldValue(
											'numeroEspelho',
											onlyNumbers(v.target.value),
										);
									}}
									error={!!formik.errors.numeroEspelho}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Select}
									title="Tipo"
									titleSize="lg"
									name="longIdTipo"
									options={consultaTipo.data}
									onChange={(v: number) => {
										formik.setFieldValue('longIdTipo', v);

										const selectedItem = consultaTipo.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue(
											'descricaoTipo',
											selectedItem[0].label,
										);
									}}
									size={92}
									required
									error={hasError(formik.errors, 'tipo')}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Select}
									title="Carroceria"
									titleSize="lg"
									name="longIdCarroceria"
									options={consultaCarroceria.data}
									onChange={(v: number) => {
										formik.setFieldValue('longIdCarroceria', v);

										const selectedItem = consultaCarroceria.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue(
											'descricaoCarroceria',
											selectedItem[0].label,
										);
									}}
									size={80}
									required
									error={hasError(formik.errors, 'carroceria')}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Select}
									title="Categoria"
									titleSize="lg"
									name="longIdCategoria"
									options={consultaCategoria.data}
									onChange={(v: number) => {
										formik.setFieldValue('longIdCategoria', v);

										const selectedItem = consultaCategoria.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue(
											'descricaoCategoria',
											selectedItem[0].label,
										);
									}}
									size={80}
									required
									error={hasError(formik.errors, 'categoria')}
								/>
							</Col>
							<Col span={11}>
								<Field
									as={Select}
									title="Cor"
									titleSize="lg"
									name="longIdCor"
									options={consultaCor.data}
									onChange={(v: number) => {
										formik.setFieldValue('longIdCor', v);

										const selectedItem = consultaCor.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue('descricaoCor', selectedItem[0].label);
									}}
									size={92}
									required
									error={hasError(formik.errors, 'cor')}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Select}
									title="Combustível"
									titleSize="lg"
									name="longIdCombustivel"
									options={consultaCombustivel.data}
									onChange={(v: number) => {
										formik.setFieldValue('longIdCombustivel', v);

										const selectedItem = consultaCombustivel.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue(
											'descricaoCombustivel',
											selectedItem[0].label,
										);
									}}
									size={80}
									// required
									// error={hasError(formik.errors, 'longIdCombustivel')}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Select}
									title="Espécie"
									titleSize="lg"
									name="longIdEspecie"
									options={consultaEspecie.data}
									onChange={(v: number) => {
										formik.setFieldValue('longIdEspecie', v);

										const selectedItem = consultaEspecie.data.filter(
											item => v === item.value,
										);

										formik.setFieldValue(
											'descricaoEspecie',
											selectedItem[0].label,
										);
									}}
									size={92}
									required
									error={hasError(formik.errors, 'especie')}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={InputMask}
									title="Capacidade Passageiro"
									titleSize="lg"
									name="capacidadePassageiro"
									mask="9"
									size={80}
									required
									error={!!formik.errors.capacidadePassageiro}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Input}
									title="Capacidade Carga"
									titleSize="lg"
									name="capacidadeCarga"
									size={92}
									required
									onChange={(v: React.ChangeEvent<HTMLInputElement>) => {
										formik.setFieldValue(
											'capacidadeCarga',
											onlyNumbers(v.target.value),
										);
									}}
									error={!!formik.errors.capacidadeCarga}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Input}
									title="Potência"
									titleSize="lg"
									name="potencia"
									size={80}
									required
									onChange={(v: React.ChangeEvent<HTMLInputElement>) => {
										formik.setFieldValue(
											'potencia',
											onlyNumbers(v.target.value),
										);
									}}
									error={!!formik.errors.potencia}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Input}
									title="Cilindrada"
									titleSize="lg"
									name="cilindrada"
									size={92}
									required
									onChange={(v: React.ChangeEvent<HTMLInputElement>) => {
										formik.setFieldValue(
											'cilindrada',
											onlyNumbers(v.target.value),
										);
									}}
									error={!!formik.errors.cilindrada}
								/>
							</Col>
						</Row>

						<Row gutter={[0, 10]}>
							<Col span={11}>
								<Field
									as={Input}
									title="CMT"
									titleSize="lg"
									name="cmt"
									size={80}
									required
									onChange={(v: React.ChangeEvent<HTMLInputElement>) => {
										formik.setFieldValue('cmt', onlyNumbers(v.target.value));
									}}
									error={!!formik.errors.cmt}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={InputMask}
									title="PBT"
									titleSize="lg"
									name="pbt"
									mask="9.99"
									size={92}
									required
									error={!!formik.errors.pbt}
								/>
							</Col>
						</Row>

						<Row>
							<Col span={11}>
								<Field
									as={InputMask}
									title="Eixos"
									titleSize="lg"
									name="eixo"
									mask="99"
									maskChar=""
									size={80}
									required
									error={!!formik.errors.eixo}
								/>
							</Col>

							<Col span={11}>
								<Field
									as={Select}
									title="Procedência do veículo"
									titleSize="lg"
									name="procedencia"
									options={data.procedenciaVeiculo}
									onChange={(v: string) =>
										formik.setFieldValue('procedencia', v)
									}
									size={92}
									required
									error={!!formik.errors.procedencia}
								/>
							</Col>
						</Row>
					</Section>
				</Col>
			</Row>
		</>
	);
};

export default DadosVeiculo;
